<script>
import WelcomePng from '@/assets/welcome.png'
export default {
  name: 'Welcome',
  render (h) {
    const welcomePng = h(
      'img',
      {
        attrs: {
          src: WelcomePng,
          width: 621,
          height: 329,
          alt: 'welcome'
        }
      }
    )

    return h(
      'div',
      {
        style: {
          background: '#fff',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      },
      [welcomePng]
    )
  }
}
</script>
